import { useState } from 'react'
import { useEffect } from 'react'
import { GetSearchingResult } from '../../../Services/ProductService'
import { useConfig } from '../../../Providers/ConfigProvider'
import { useShop } from '../../../Providers/ShopProvider'
import { useParams } from '../../../Providers/ParamsProvider'
import axios from 'axios'

export default function useSearchingResults(searchingString) {
  const { api } = useConfig()
  const { productsFilter } = useShop()
  const { searchingQueryDelay, searchingQueryCharNumber } = useParams()
  const [result, setResult] = useState([])
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(false)
  const [productsRelatesSuppliers, setProductsRelatesSuppliers] = useState([])
  const [productsCategories, setProductsCategories] = useState([])
  const [isProductsLoaded, setIsProductsLoaded] = useState(false) //Czy funkcja z timerem przetworzyła dane 

  useEffect(() => {
    const source = axios.CancelToken.source()
    if (searchingString.length >= searchingQueryCharNumber) {
      const timer = setTimeout(async () => {
        handleGetSearchingResult(searchingString, null, source.token)
      }, searchingQueryDelay)
      // Reset timera przy każdej zmianie "searchingString"
      return () => clearTimeout(timer)
    } else {
      setResult([])
      setProducts([])
      setIsProductsLoaded(false)
      setProductsCategories([])
    }

    return () => source.cancel()
  }, [searchingString])

  const handleGetSearchingResult = async (searchingString, allArticles = null, cancelToken = null) => {
    setLoading(true)
    try {
      const isAllArticles = allArticles !== null && allArticles !== undefined ? allArticles : productsFilter.AllArticles
      const newProductsFilter = {
        ...productsFilter,
        SearchingQuery: searchingString,
        AllArticles: isAllArticles
      }
      const res = await GetSearchingResult(api, newProductsFilter, cancelToken)
      setResult(res.data.results)
      setProducts(res.data.products)
      setProductsRelatesSuppliers(res.data.suppliers)
      setProductsCategories(res.data.productsCategories)
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error(error)
      }
    }
    finally {
      setLoading(false)
      setIsProductsLoaded(true)
    }
  }

  return { result, loading, products, isProductsLoaded, productsRelatesSuppliers, productsCategories, handleGetSearchingResult }
}

